const preselectVariantFromURL = ({
  variantsData,
  optionNames,
  form,
  selectedOptions,
  sellingPlanIdInput,
  updateSelectedOption,
  updateVariantDetails
}) => {
  const url = new URL(window.location.href);
  const variantIdFromURL = url.searchParams.get('variant');
  if (!variantIdFromURL) return;

  const variant = variantsData.find(v => String(v.id) === variantIdFromURL);
  if (!variant) return;

  optionNames.forEach((name, i) => {
    const value = variant[`option${i + 1}`];
    selectedOptions[name] = value;

    const input = form.querySelector(`[name="${name}"][value="${value}"]`);
    if (input) {
      input.checked = true;
    } else {
      const select = form.querySelector(`select[name="${name}"]`);
      if (select) select.value = value;
    }

    updateSelectedOption(selectedOptions, name, value, updateVariantDetails);
  });

  if (sellingPlanIdInput && url.searchParams.get('selling_plan')) {
    const sellingPlanFromURL = url.searchParams.get('selling_plan');
    sellingPlanIdInput.value = sellingPlanFromURL;
    const sellingPlanInputRadio = form.querySelector(`[data-selling-plan-radio][value="${sellingPlanFromURL}"]`);
    if (sellingPlanInputRadio) {
      sellingPlanInputRadio.checked = true;
    }
    updateVariantDetails();
  }
};

export default preselectVariantFromURL;
